import ReactHelmet from 'react-helmet';
import { Loader } from '../../../../components/Loader';
import { SomethingWentWrongWithReport } from '../../../../components/SomethingWentWrong';
import { TopContainer } from '../../../components/TopContainer';
import { TopNav } from '../../../components/TopNav';
import { MaybeImpersonationBanner } from '../../../components/ImpersonationBanner';
import { useStandaloneMoment } from '../service';
import { StandaloneAppPageMomentOverviewInner } from './InnerPage';

export const StandaloneAppPageMoment = ({
  accessToken,
  v
}: {
  accessToken: string;
  v: number;
}) => {
  const [d, loading, error] = useStandaloneMoment(accessToken, v);

  // The model is updated e.g. when sub tasks complete. Through this mechanic
  // we gather an updated state of the moment - but there's no need to show
  // a loader for it! It can just update in place.
  if (loading && !d) {
    return <Loader />;
  }

  if (error || !d) {
    return (
      <SomethingWentWrongWithReport
        error={error}
        context={{ page: 'standalone_moment', accessToken }}
      />
    );
  }

  console.log('D', d);
  return (
    <>
      <ReactHelmet>
        <title>{d.data.subject}</title>
      </ReactHelmet>
      <MaybeImpersonationBanner user={d.data.user} />
      <TopContainer>
        <TopNav
          d={{
            accessToken: d.data.accessToken,
            org: d.data.org,
            title: d.data.subject,
            mail: d.data.from
          }}
        />
      </TopContainer>
      <StandaloneAppPageMomentOverviewInner moment={d} showTopBanner />
    </>
  );
};
